import React from 'react';

function Stats() {
  const stats = [
    { value: '1000+', label: 'Membres actifs' },
    { value: '50+', label: 'Projets financés' },
    { value: '15%', label: 'Rendement moyen' },
    { value: '100%', label: 'Sécurisé' }
  ];

  return (
    <section className="stats">
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <h3>{stat.value}</h3>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;
